import { angleDownCircled } from 'components/icons'
export default {
    name: 'showLessBtn',
    components: {
        angleDownCircled
    },
    props: {
        expanded: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggleShowLess() {
            this.$emit('toggleShowLess')
        }
    }
}